import { useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import { useAuth } from "../context/AuthContext";
import Navbar from "../components/Navbar";
import { Link } from "react-router-dom";

export default function Upgrade() {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleUpgrade() {
    setLoading(true);
    setError("");
    try {
      const createCheckoutSession = httpsCallable(functions, "createCheckoutSession");
      const result = await createCheckoutSession({
        priceId: process.env.REACT_APP_STRIPE_PRICE_ID,
        successUrl: `${window.location.origin}/upgrade/success`,
        cancelUrl: `${window.location.origin}/upgrade`,
      });
      window.location.href = result.data.url;
    } catch (err) {
      setError("Something went wrong. Please try again.");
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#F0F1EC" }}>
      <Navbar />
      <div className="max-w-lg mx-auto px-6 py-20">
        <div className="card p-10 text-center">

          <span className="font-condensed text-xs tracking-widest uppercase px-3 py-1 rounded-full inline-block mb-6"
            style={{ backgroundColor: "#EDFFD0", color: "#3A6600" }}>
            ⚡ PREMIUM
          </span>

          <h2 className="font-display text-6xl tracking-wider mb-4" style={{ color: "#0A0B0F" }}>
            GO PREMIUM
          </h2>
          <p className="font-condensed text-gray-400 tracking-wide text-lg mb-8">
            Pay once, keep premium forever. No subscription, no hidden fees.
          </p>

          {/* Feature list */}
          <div className="rounded-xl p-6 mb-8 text-left space-y-4"
            style={{ backgroundColor: "#F5F6F2", border: "1px solid #E0E2DB" }}>
            {[
              { icon: "✅", label: "Create unlimited private leagues" },
              { icon: "✅", label: "Invite friends with a unique code or link" },
              { icon: "✅", label: "Everything in the free tier" },
            ].map((item) => (
              <div key={item.label} className="flex items-center gap-3">
                <span>{item.icon}</span>
                <span className="font-condensed text-lg tracking-wide" style={{ color: "#0A0B0F" }}>
                  {item.label}
                </span>
              </div>
            ))}
          </div>

          <div className="mb-2">
            <span className="font-display text-7xl tracking-wider" style={{ color: "#0A0B0F" }}>
              £4.99
            </span>
          </div>
          <p className="font-condensed text-gray-400 tracking-wide mb-8">one-time payment · yours forever</p>

          {error && (
            <div className="mb-4 px-4 py-3 rounded-xl font-condensed tracking-wide text-red-600"
              style={{ backgroundColor: "#FFF0F0", border: "1px solid #FFCCCC" }}>
              {error}
            </div>
          )}

          <button
            onClick={handleUpgrade}
            disabled={loading}
            className="btn-lime w-full py-4 rounded-xl text-xl mb-4"
          >
            {loading ? "REDIRECTING TO PAYMENT..." : "UPGRADE FOR £4.99"}
          </button>

          <p className="font-condensed text-gray-400 text-sm tracking-wide">
            Secured by Stripe · No card details stored by Predictorz
          </p>
        </div>
      </div>
    </div>
  );
}